import type { IconProps } from './types';

export const H1Icon = (props: IconProps) => {
  const {
    size = 24,
    width = size,
    height = size,
    color = 'currentColor',
    className,
  } = props;

  return (
    <svg
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M15.0354 10.6429C15.0354 10.2287 15.3713 9.89299 15.7854 9.89286C16.1736 9.89286 16.4929 10.1878 16.5315 10.5657L16.5354 10.6429V17.6067H18.3567L18.4338 17.6106C18.8119 17.649 19.1065 17.9686 19.1067 18.3567C19.1067 18.745 18.812 19.0644 18.4338 19.1028L18.3567 19.1067H13.2141C12.8 19.1067 12.4641 18.7709 12.4641 18.3567C12.4643 17.9427 12.8001 17.6068 13.2141 17.6067H15.0354V13.0452C14.6794 13.2201 14.2801 13.3216 13.8567 13.3216H13.2141C12.8 13.3215 12.4642 12.9857 12.4641 12.5716C12.4641 12.1574 12.8 11.8216 13.2141 11.8216H13.8567C14.5076 11.8216 15.0354 11.2938 15.0354 10.6429ZM8.60669 15.7854V9.46415H2.39282V15.7854C2.39282 16.1996 2.05704 16.5354 1.64282 16.5354C1.22861 16.5354 0.892822 16.1996 0.892822 15.7854V1.64286C0.892822 1.22864 1.22861 0.892857 1.64282 0.892857C2.05704 0.892857 2.39282 1.22864 2.39282 1.64286V7.96415H8.60669V1.64286C8.60669 1.22878 8.94267 0.893084 9.35669 0.892857C9.7709 0.892857 10.1067 1.22864 10.1067 1.64286V15.7854C10.1067 16.1996 9.7709 16.5354 9.35669 16.5354C8.94267 16.5352 8.60669 16.1995 8.60669 15.7854Z"
        fill={color}
      />
    </svg>
  );
};
